import UpdateAgendaItemData from "@/domain/entities/agenda/UpdateAgendaItemData";
import { UpdateAgendaItemData as UpdateAgendaItemDataSDK } from "@cs_teamwaydev/mailvista-sdk_react";

const updateAgendaItemDataToSDKMapper = (
    updateAgendaItemData: UpdateAgendaItemData,
): UpdateAgendaItemDataSDK => ({
    subject: updateAgendaItemData.subject,
    description: updateAgendaItemData.description,
    location: updateAgendaItemData.location,
    timeUpdate: updateAgendaItemData.timeUpdate
        ? {
              start: updateAgendaItemData.timeUpdate.start,
              end: updateAgendaItemData.timeUpdate.end,
              isAllDay: updateAgendaItemData.timeUpdate.isAllDay,
          }
        : undefined,
    attendees: updateAgendaItemData.attendees,
});

export default updateAgendaItemDataToSDKMapper;
